import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import common from '@/utils/common'
import hostPath from '@config/host'
// 导入样式表
import 'element-ui/lib/theme-chalk/index.css'
// 判断当前项目环境，引入项目CSS
import './assets/css/common.scss'
import * as echarts from 'echarts'
// 使用ElementUI组件
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale'
// import enLocale from 'element-ui/lib/locale/lang/en'
import 'babel-polyfill' // 引入兼容性插件
// 使用axios请求数据
import axios from 'axios'
import '@config/axios'
/* 引入公用filter */
import filter from '@/mixin/filter'
Vue.mixin(filter) // 混入公用filter

const projectData = require('@/utils/projectData.json')

const getSysType = hostPath.sysType
// 主题样式处理
let ElStyle = document.createElement('link')
ElStyle.href = projectData[getSysType].style
ElStyle.rel = 'stylesheet'
ElStyle.type = 'text/css'
document.head.appendChild(ElStyle)
// 设置标题
document.title = projectData[getSysType].title
// 设置favicon
document
  .getElementById('mainHeadFavicon')
  .setAttribute('href', projectData[getSysType].ico)

// locale.use(enLocale) // 使用英文
locale.use(locale)
Vue.use(ElementUI, {locale})

Vue.prototype.$ajax = axios
Vue.prototype.$echarts = echarts
Vue.prototype.$store = store

Vue.config.productionTip = false

// 获得菜单列表
let setListMenu = ''
// 路由跳转前处理
router.beforeEach((to, from, next) => {
  // 跳转前先检测打开的页面链接是否不是'不需要登录的页面'，且没有token值，跳转到登录页
  const getTK = store.state.sys.tk ? store.state.sys.tk : common.getToken()
  let flag = true
  if (!getTK && to.name !== 'login') {
    router.push({
      name: 'login'
    })
    flag = false
  }

  // 菜单处理
  if (setListMenu.length <= 0) {
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      setListMenu = window.JSON.parse(getListMenu)
    }
  }
  if (setListMenu && setListMenu.length > 0) {
    setListMenu.some(val => {
      if (to.name === val.menuUrl) {
        // 浏览器标题显示
        document.title = common.isEnLan() ? val.menuNameEn : val.menuName
        if (val.menuLevel === 2) {
          store.dispatch('getItemMenu', {
            mainMenuId: val.menuId,
            menuId: val.customMenuId
          })
          common.setOneMenuId(val.menuId)
          common.setTwoMenuId(val.customMenuId)
        } else if (val.menuLevel === 3) {
          store.dispatch('getItemMenu', {
            mainMenuId: val.parentMenuId,
            menuId: val.menuId
          })
          common.setOneMenuId(val.parentMenuId)
          common.setTwoMenuId(val.menuId)
        }
        return true
      }
    })
  }

  flag && next()
})

/**
 * 语言处理
 * */
common.setLanguage()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js